import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Legacy route: `/contractiq/contracts/:id/review/submit`.
 * Submit-for-review UI was removed; always send users to the review summary (spec 034).
 */
export const ContractSubmitForReviewPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/contractiq/contracts", { replace: true });
      return;
    }
    navigate(`/contractiq/contracts/${id}/review`, { replace: true });
  }, [id, navigate]);

  return (
    <p className="text-muted-foreground transition-all duration-200 ease-in-out">Loading…</p>
  );
};
